import {Component, Input} from '@angular/core';
import {NgIf} from '@angular/common';
import {Subject} from 'rxjs';
import {BsModalRef} from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-confirmation-popup-large',
  templateUrl: './confirmation-popup-large.component.html',
  styleUrl: './confirmation-popup-large.component.scss'
})
export class ConfirmationPopupLargeComponent {
  @Input({required: true}) title: string;
  @Input({required: true}) message: string;
  @Input() showInnerHtml: boolean = false;
  @Input() cancelButtonText: string = 'Cancel';
  @Input() confirmButtonText: string = 'Confirm';

  subject: Subject<boolean>;

  constructor(
    public bsModalRef: BsModalRef
  ) {}

  onClose(): void {
    this.bsModalRef.hide();
    this.subject.next(false);
    this.subject.complete();
  }

  onConfirm(): void {
    this.bsModalRef.hide();
    this.subject.next(true);
    this.subject.complete();
  }
}
